module.exports = __webpack_public_path__ + "static/img/10.cafd16c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/10.png
// module id = lU5x
// module chunks = 0